module.exports = {
  "$id": "infomation",
  "type": "object",
  "title": "完善个人资料",
  "properties": {
    "surname": {
      "title": "中文姓",
      "type": "string",
      "customValidate": "zhLastName"
    },
    "name": {
      "title": "中文名",
      "type": "string",
      "customValidate": "zhFirstName"
    },
    "certType": {
      "title": "证件类型",
      "type": "string"
    },
    "certNo": {
      "title": "证件号",
      "type": "string",
      "customValidate": "certNo"
    },
    "birthDate": {
      "title": "出生日期",
      "type": "string",
      "format": "date"
    },
    "gender": {
      "title": "性别",
      "type": "string"
    }
    // "phone": {
    //   "title": "手机号",
    //   "type": "string",
    //   "format": "phone"
    // }
  },
  "required": [
    "surname",
    "name",
    "certType",
    "certNo"
    // "phone"
  ],
  "errorMessage": {
    "surname": {
      "required": "中文姓不能为空"
    },
    "name": {
      "required": "中文名不能为空"
    },
    "certType": {
      "required": "请选择证件类型"
    },
    "certNo": {
      // "message": "证件号不正确",
      "required": "请输入证件号"
    }
    // "phone": {
    //   "message": "手机号码不正确",
    //   "required": "手机号码不能为空"
    // }
  }
}
